import { FunctionComponent, ReactNode } from 'react';

import styles from './NavTopInner.module.scss';

export type NavTopInnerProps = {
  children: ReactNode;
};

type FC = FunctionComponent<NavTopInnerProps>;

const NavTopInner: FC = ({ children }: NavTopInnerProps) => <div className={styles.container}>{children}</div>;

export default NavTopInner;
